var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStethoscopeWithBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#F0F0F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8777_24759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.5 15.6465V19.2934H55.125V30.234C55.125 32.1684 54.3612 34.0236 53.0015 35.3914C51.6419 36.7593 49.7978 37.5277 47.875 37.5277C45.9522 37.5277 44.1081 36.7593 42.7485 35.3914C41.3889 34.0236 40.625 32.1684 40.625 30.234V19.2934H44.25V15.6465H37V30.234C37.0045 32.817 37.9165 35.3154 39.5748 37.2874C41.2332 39.2594 43.5311 40.5781 46.0625 41.0105V52.1152C46.0625 55.0168 44.9168 57.7996 42.8773 59.8514C40.8378 61.9031 38.0717 63.0558 35.1875 63.0558C32.3033 63.0558 29.5372 61.9031 27.4977 59.8514C25.4583 57.7996 24.3125 55.0168 24.3125 52.1152V40.9155C26.0211 40.4717 27.5101 39.4162 28.5005 37.9469C29.4909 36.4776 29.9146 34.6954 29.6922 32.9343C29.4699 31.1732 28.6167 29.5541 27.2927 28.3806C25.9686 27.207 24.2646 26.5596 22.5 26.5596C20.7354 26.5596 19.0314 27.207 17.7073 28.3806C16.3833 29.5541 15.5301 31.1732 15.3078 32.9343C15.0855 34.6954 15.5092 36.4776 16.4996 37.9469C17.4899 39.4162 18.9789 40.4717 20.6875 40.9155V52.1152C20.6875 55.984 22.2152 59.6944 24.9345 62.4301C27.6537 65.1658 31.3419 66.7027 35.1875 66.7027C39.0332 66.7027 42.7213 65.1658 45.4406 62.4301C48.1598 59.6944 49.6875 55.984 49.6875 52.1152V41.0105C52.2189 40.5781 54.5168 39.2594 56.1752 37.2874C57.8336 35.3154 58.7456 32.817 58.75 30.234V15.6465H51.5ZM18.875 33.8808C18.875 33.1596 19.0876 32.4545 19.4859 31.8547C19.8843 31.255 20.4504 30.7876 21.1128 30.5116C21.7752 30.2355 22.504 30.1633 23.2072 30.304C23.9104 30.4448 24.5563 30.7921 25.0633 31.3021C25.5702 31.8121 25.9155 32.4619 26.0554 33.1694C26.1952 33.8768 26.1234 34.6101 25.8491 35.2764C25.5747 35.9428 25.1101 36.5124 24.514 36.9131C23.9178 37.3138 23.217 37.5277 22.5 37.5277C21.5389 37.5266 20.6176 37.142 19.938 36.4583C19.2584 35.7747 18.8761 34.8477 18.875 33.8808Z",
    fill: "#9B9B9B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8777_24759"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58.3499,
    fill: "white",
    transform: "translate(8 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStethoscopeWithBackground);
export default __webpack_public_path__ + "static/media/stethoscopeWithBackground.7e08ee2963e56a81c1a679071c60be8c.svg";
export { ForwardRef as ReactComponent };